import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_TIMESHEETS_FOR_ADMINS } from "src/api-setup/api-endpoints";
import { transformDateTime } from "src/lib/date-time.util";
import { GridColumnDataMapper } from "src/utils/utils";

export const getAdminTimesheets = async (
  cookiesData,
  dispatch,
  startDate,
  endDate,
  status,
  selectedSpecialties,
  selectedContractTypes,
  selectedProviders,
  skip = 0,
  take = 50,
  filterString = null,
  sortNumber = 1,
  sortOrder = "DESC"
) => {
  if (!cookiesData) return { data: [], totalCount: 0, columData: [] };

  try {
    const apiHeaders = generateHeader();

    const startDateString = startDate
      ? `${transformDateTime({
          date: startDate,
          format: "YYYY-MM-DD",
          includeTime: false,
        })} 00:00:00`
      : null;
    const endDateString = endDate
      ? `${transformDateTime({
          date: endDate,
          format: "YYYY-MM-DD",
          includeTime: false,
        })} 23:59:59`
      : null;

    const specialtyIds =
      selectedSpecialties && selectedSpecialties.length > 0
        ? selectedSpecialties.map((item) => item.specialty_mstr_key).join(",")
        : null;

    const contractTypeIds =
      selectedContractTypes && selectedContractTypes.length > 0
        ? selectedContractTypes.map((item) => item.contract_type_mstr_key).join(",")
        : null;

    const providerIds =
      selectedProviders && selectedProviders.length > 0
        ? selectedProviders.map((item) => item.provider_mstr_key).join(",")
        : null;

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_provider_mstr_key: providerIds,
      in_specialty_mstr_key: specialtyIds,
      in_contract_type_mstr_key: contractTypeIds,
      in_contract_mstr_key: null,
      in_status: status,
      in_device_local_tz: "America/New_York",
      in_start_date: startDateString,
      in_end_date: endDateString,
      in_filter: filterString,
      in_sort_number: sortNumber,
      in_sort_order: sortOrder,
      in_page_row_offset: skip,
      in_page_rows: take,
      in_export_flag: 0,
    };

    const response = await POSTAPI(false, GET_TIMESHEETS_FOR_ADMINS, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.row_result) {
      const flattenedData = Array.isArray(response.data.row_result) 
        ? response.data.row_result 
        : [];

      // Get total count from response
      const totalCount = response.data.out_parameters?.out_total_rows || 0;

      // Parse column metadata from XML (empty default alias since columns are CTE aliases)
      let columData = [];
      if (response.data.out_parameters?.out_columns_xml) {
        columData = GridColumnDataMapper(response.data.out_parameters.out_columns_xml, "");
      }

      return { data: flattenedData, totalCount, columData };
    }

    return { data: [], totalCount: 0, columData: [] };
  } catch (error) {
    console.error(error);
    return { data: [], totalCount: 0, columData: [] };
  }
};

export const getExportAdminTimesheets = async (
  cookiesData,
  dispatch,
  startDate,
  endDate,
  status,
  selectedSpecialties,
  selectedContractTypes,
  selectedProviders,
  filterString = null,
  sortNumber = 1,
  sortOrder = "DESC"
) => {
  if (!cookiesData) return { data: [], columData: [] };

  try {
    const apiHeaders = generateHeader();

    const startDateString = startDate
      ? `${transformDateTime({
          date: startDate,
          format: "YYYY-MM-DD",
          includeTime: false,
        })} 00:00:00`
      : null;
    const endDateString = endDate
      ? `${transformDateTime({
          date: endDate,
          format: "YYYY-MM-DD",
          includeTime: false,
        })} 23:59:59`
      : null;

    const specialtyIds =
      selectedSpecialties && selectedSpecialties.length > 0
        ? selectedSpecialties.map((item) => item.specialty_mstr_key).join(",")
        : null;

    const contractTypeIds =
      selectedContractTypes && selectedContractTypes.length > 0
        ? selectedContractTypes.map((item) => item.contract_type_mstr_key).join(",")
        : null;

    const providerIds =
      selectedProviders && selectedProviders.length > 0
        ? selectedProviders.map((item) => item.provider_mstr_key).join(",")
        : null;

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_provider_mstr_key: providerIds,
      in_specialty_mstr_key: specialtyIds,
      in_contract_type_mstr_key: contractTypeIds,
      in_contract_mstr_key: null,
      in_status: status,
      in_device_local_tz: "America/New_York",
      in_start_date: startDateString,
      in_end_date: endDateString,
      in_filter: filterString,
      in_sort_number: sortNumber,
      in_sort_order: sortOrder,
      in_page_row_offset: 0,
      in_page_rows: 500, // Will be overridden by stored procedure when export_flag = 1
      in_export_flag: 1,
    };

    const response = await POSTAPI(false, GET_TIMESHEETS_FOR_ADMINS, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.row_result) {
      const flattenedData = Array.isArray(response.data.row_result) 
        ? response.data.row_result 
        : [];

      // Get column data from response if available
      let columData = [];
      if (response.data.out_parameters?.out_columns_xml) {
        columData = GridColumnDataMapper(response.data.out_parameters.out_columns_xml, "");
      }

      return { data: flattenedData, columData };
    }

    return { data: [], columData: [] };
  } catch (error) {
    console.error(error);
    return { data: [], columData: [] };
  }
};
